import { Link } from "react-router-dom";

export function NotFoundPage() {
	return (
		<div
			style={{
				minHeight: "100vh",
				display: "grid",
				placeItems: "center",
				padding: 24,
				textAlign: "center",
			}}
		>
			<div>
				<h1 style={{ margin: 0, fontSize: 64, fontWeight: 600 }}>404</h1>
				<p style={{ color: "var(--muted)", marginTop: 12 }}>
					This page isn't part of INSIGHTS v0.
				</p>
				<Link to="/" style={{ color: "var(--accent)" }}>
					Go to Home Brief →
				</Link>
			</div>
		</div>
	);
}
